import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const root = (theme: Theme) => css`
  pre {
    background-color: ${theme.palette.tertiary.lowContrast};
    border-radius: ${theme.borderRadius.sm};
    padding: ${theme.spacing[16]};
  }
  code {
    font-family:
      SFMono-Regular,
      Consolas,
      Liberation Mono,
      Menlo,
      monospace;
    border-radius: ${theme.borderRadius.sm};
    background-color: ${theme.palette.tertiary.lowContrast};
    padding: ${theme.spacing[4]};
  }
  blockquote {
    padding: 0 1em;
    color: ${theme.palette.tertiary.upperMediumContrast};
    border-left: 0.25em solid ${theme.palette.tertiary.mediumContrast};
  }
  a {
    color: ${theme.palette.primary.mainContrast};
    text-decoration: none;
    font-weight: 500;
  }
  hr {
    height: 1px;
    width: 100%;
    border: none;
    background: ${theme.palette.ghost.mediumContrast};
    margin: 0;
  }
  b,
  strong {
    font-weight: 500;
  }
`;
